<template>
  <div id="mini">
    <div class="left">
      <div>
        <el-popover
          placement="top"
          :trigger="triggerType"
          :offset="-18"
          :content="nftInfo.name"
        >
          <div slot="reference" class="name">{{ nftInfo.name }}</div>
        </el-popover>
      </div>
      <p class="num" v-if="nftInfo.type === 'MINT'">x{{ nftInfo.quantity }}</p>
      <p class="num" v-else>{{ nftInfo.uniqueId }}</p>
    </div>
    <div class="right"><img :src="nftInfo.picture" alt="" /></div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import common from "@/utils/common";

export default {
  name: "mini",
  data() {
    return {
      triggerType: "hover",
    };
  },
  mounted() {
    //判断是pc还是移动端，用于展示的提示信息是click还是hover触发
    this.triggerType = common.equipmentEnd === "pc" ? "hover" : "click";
  },
  activated() {
    //判断是pc还是移动端，用于展示的提示信息是click还是hover触发
    this.triggerType = common.equipmentEnd === "pc" ? "hover" : "click";
  },
  computed: {
    ...mapState("buyNftHome", {
      nftInfo: (state) => state.nftInfo,
    }),
  },
};
</script>

<style lang="scss" scoped>
#mini {
  height: 0.9rem;
  background: #f4f5f7;
  border-radius: 0.06rem;
  display: flex;
  align-items: center;
  padding: 0.1rem 0.16rem;
  .left {
    .name {
      max-width: 2.2rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-family: Medium;
      font-weight: 500;
      font-size: 0.16rem;
      line-height: 0.19rem;
      color: #031633;
      cursor: pointer;
    }
    .num {
      font-family: Medium;
      font-weight: 500;
      font-size: 0.16rem;
      line-height: 0.19rem;
      color: #6e7687;
      margin-top: 0.12rem;
    }
  }
  .right {
    margin-left: auto;
    width: 0.7rem;
    height: 0.7rem;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    border-radius: 0.06rem;
    img {
      height: 0.7rem;
      border-radius: 0.06rem;
    }
  }
}
</style>
